<div class="row">
  <div class="col">
    <label class="mb-2 d-block">{{ field.label }}</label>

    <mat-radio-group [formControl]="control" [required]="field.isRequired">
      @for (option of field.options; track option) {
      <mat-radio-button [value]="option.value" class="d-block mb-1">
        {{ option.value }}
      </mat-radio-button>
      }
    </mat-radio-group>

    @if (control.hasError('required') && control.touched) {
    <mat-error> {{ field.label }} is required </mat-error>
    }
  </div>
</div>
